import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";
import { downloadExcel } from "react-export-table-to-excel";

const MySwal = withReactContent(Swal2);

const ImportLeadSend = (props) => {
  const [loading, setLoading] = useState(true);
  const [array, setArray] = useState([]);
  const [arrayNon, setArrayNon] = useState([]);
  const [fileInfo, setFileInfo] = useState([]);

  const fileReader = new FileReader();

  const fetchLeadsImport = async () => {
    var body = {
      leads: array,
    };

    await fetch("https://apisellcrm.ftpeople.pl/importLeadsSend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zaimportowano",
          text: "leady do wysyłki",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const validate = () => {
    if (array.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const importLead = () => {
    if (validate()) {
      setLoading(true);
      fetchLeadsImport();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wgraj",
        text: "prawidłowy plik",
      }).then(async (result) => {});
    }
  };

  const checkCompany = (company) => {
    var bool = false;
    if (company === "CHF" || company === "SKD" || company === "WIBOR") {
      bool = true;
    }

    return bool;
  };

  const csvFileToArray = (string) => {
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");

    const array1 = [];
    const arrayN = [];
    csvRows.map((i, index) => {
      const values = i.split(";");
      if (checkCompany(!values[3] ? false : values[3].trim())) {
        var data = {
          name: values[0],
          phone: values[1],
          mail: values[2],
          source: "SEND MANUAL",
          company: values[3].trim(),
        };
        array1.push(data);
      } else if (values.length !== 1) {
        var data = {
          name: values[0],
          phone: values[1],
          mail: values[2],
          source: "SEND MANUAL",
          company: values[3].trim(),
        };
        arrayN.push(data);
      }
    });
    csvRows.map((i) => console.log(i.split(";")[3]));
    setFileInfo({
      rows: csvRows.filter(
        (i) => i.split(";")[3] !== undefined && i.split(";")[3] !== ""
      ).length,
      rowsAcc: array1.length,
    });
    setArray(array1);
    setArrayNon(arrayN);
    setLoading(false);
  };

  const readFile = (e) => {
    if (e.target.files[0]) {
      e.preventDefault();
      setLoading(true);

      if (e.target.files[0]) {
        fileReader.onload = function (event) {
          const text = event.target.result;
          csvFileToArray(text);
        };

        fileReader.readAsText(e.target.files[0], "Windows-1250");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const createExcelDS = () => {
    var tab = [];
    arrayNon.map((el) => {
      tab.push([el.name, el.phone, el.mail, el.source, el.company]);
    });
    return tab;
  };

  const exportArrayNon = (e) => {
    var header = ["name", "phone", "mail", "source", "company"];
    downloadExcel({
      fileName: "importNon_report_" + new Date(),
      sheet: "data",
      tablePayload: {
        header,
        body: createExcelDS(),
      },
    });
  };

  return (
    <>
      <div
        style={{
          width: "50vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "10vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                IMPORTUJ LEADY DO WYSYŁKI
                <a
                  style={{ fontSize: ".8vw" }}
                  href="https://ftpeople.pl/wp-content/uploads/2025/03/lead_splitter_example-1-1_send.csv"
                >
                  (pobierz przykład)
                </a>
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  plik <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="file"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                    border: "none",
                  }}
                  onChange={readFile}
                />
              </div>
              <div
                style={{ width: "45%", textAlign: "left", fontSize: ".8vw" }}
              >
                Ilość rekordów: {fileInfo.rows ? fileInfo.rows : 0}
                <br />
                Ilość rekordów prawidłowych:{" "}
                {fileInfo.rowsAcc ? fileInfo.rowsAcc : 0}
                {arrayNon.length > 0 ? (
                  <>
                    <button
                      className="loginButtonLogin"
                      value="yes"
                      style={{
                        marginTop: "15px",
                        backgroundColor: "navy",
                        borderColor: "navy",
                        fontSize: ".5vw",
                        width: "50%",
                      }}
                      onClick={exportArrayNon}
                    >
                      POBIERZ NIEPRAWIDŁOWE - {arrayNon.length}
                    </button>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div style={{ marginTop: "50px", textAlign: "left" }}>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                }}
                onClick={importLead}
              >
                IMPORTUJ
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ImportLeadSend;
